/* PhotoHouse V2 — progressive, independent UI enhancement.
   Never changes prices, writes Shopify variant IDs, calls cart endpoints,
   or replaces Kingdom gallery / Langify / search and sort handlers.
   Works only after Kingdom has constructed its original select control.
*/
(function () {
  'use strict';

  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function getKind(select) {
    if (!select) return null;
    var holder = select.closest('.product__variant-holder');
    var label = holder && holder.querySelector('label');
    // A standalone frame product can have an option called "Select a frame"
    // while every choice is actually a numeric DIMENSION. The option values
    // take precedence over the label; no false colour/frame icons are drawn.
    var values=toArray(select.options).map(function(o){return (o.value||'').trim();});
    if(values.length>1&&values.every(function(v){
      return /^\d+(?:[.,]\d+)?\s*[x×*]\s*\d+(?:[.,]\d+)?(?:\s*(?:cm|ס[״"\x27]?מ))?$/i.test(v);
    }))return 'size';
    var name = (label ? label.textContent : '').trim().toLowerCase();
    if (!name) return null;
    if (/גודל|מידה|size|dimensions|print size|הדפס/.test(name)) return 'size';
    if (/מסגר|frame|framing/.test(name)) return 'frame';
    return null;
  }
  function getFinish(value) {
    var v = value.trim().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ');
    if (/ללא מסגרת|הדפסה בלבד|הדפס בלבד|printing only|print only|without frame|no frame|unframed/.test(v)) return 'print';
    if (/שחור|black/.test(v)) return 'black';
    if (/לבן|white/.test(v)) return 'white';
    if (/דיבונד.*(אקריל|זכוכית|acrylic|glass)|dibond.*(acrylic|glass)/.test(v)) return 'dibond-glass';
    if (/דיבונד|dibond/.test(v)) return 'dibond';
    if (/ענבר|amber/.test(v)) return 'amber';
    if (/זהב|gold/.test(v)) return 'gold';
    if (/אלון.*(בהיר|טבעי)|light oak|natural oak/.test(v)) return 'light-oak';
    if (/אלון.*כהה|כהה.*אלון|וונגה|ונגה|dark oak|wenge|dark wood/.test(v)) return 'dark-oak';
    if (/אלון.*(בהיר|טבעי)|light oak|natural|עץ|oak|wood/.test(v)) return 'light-oak';
    return 'neutral';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  // PhotoHouse client-approved frame silhouettes. Decorative SVG only:
  // the original variant select, price calculations and cart handlers remain
  // untouched. Palettes reproduce the supplied Print/Black/Wenge/Amber sample.
  // Exact merchant icon images from the four separate client PNG references.
  // Embedded unchanged as data URIs; no approximating/generated vector artwork.
  var phReviewClientIcons={"print":"iVBORw0KGgoAAAANSUhEUgAAADwAAAAnCAYAAABT7SsqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAI7SURBVGhD7Zg/b9pAGMafA6NEGNtiY/CEkHdCUyRSJDb+dqNSOrI1n4DJKQwINhZWZlYaVga8IjEDG4IPwMAfoQC5DkmRemlru2rS+OA3Pu9Z8k/v3fl8hFJKcUS42IB3jk6Y2JnS8/kcu92OjV8FQgjcbjcURYHL9fd9siWcSCQwmUzY+NUIhUJoNptQVfWX0oQQNnqGLeF0Oo1yuYxgMMiWXpxqtYrhcIjt/T1uv97i8vI9zs7OATy+vhVZ2BXOZrOo1+vQNI0tvTiVSgWhUAgPD3v0+33kch8Rj8fh8Xgsy8JJmxYhBH6/H9fXnxGJvEO73YZhGNhut+zQP+IY4R8QQpDL5XARvkCn00Gv18Nms2GH/RbHCQOAoijIf8ojFovh7tsdBoPB49fDwuJ0pDAhBD6fD/l8HlcfrlAqlTAajbDdmU9vRwrjSVoQBGSzWdzcfIGu6zAMw/Sc4JhdWtd1TKdTaJoGQRAOOzOlFOv1Gq1WC6lUCrVaDV6vl338gGM6nEwmEYlEIMsyZFmGJEmQJAmyLCMQCKBQKIBSCtP+URtkMhk6Ho/Z+E0wm81osViky+WSLf2EYzr8rzgJ885JmHdOwrzDl7CF/2K+hC3Al7DJqRLcCVuAM2HzFvMlfEybFqUU+/2ejZ/BlfDOwg0mN8J4kjaDK2ErnIR5x9atZTQahaqqkGWZLf13VqsVRFFEo9GAKIps+YAt4W63i8ViwcZvBlVVEQ6HIQgCWzpgS5gHjm4NH53wd58BmeoeVN76AAAAAElFTkSuQmCC","black":"iVBORw0KGgoAAAANSUhEUgAAADcAAAAnCAYAAACrDdDdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIdSURBVGhD7ZkxrqpAFIZ/BryiIiDqRkxsbOxt3IOFtbUbcCu2JLY2JrbuwEpjg4YIgoDivErznDyFa95FueFLpplzMvDBOZMwcJRSil8KYSd+E5lcWuGe9Zzv+7BtG09S3o6qqsjlcuw0ECWn6zoGgwGCIGBDHwGlFLquo9lssiEgSm48HqPf70OSJCiKAkI+o4ovlwtM08R2u8VsNkOr1WJTgDg9p2kaBEGA4zgghEAQhLcOSiksy4IoiiiXy+zt3hEpRwiBqqoAANM02XCihGEIy7LA8zxkWQbHcWzKHZFyAMBxHGRZBiEEu90Op9MJ5/M58bHf7yEIAiqVSqQY4soBAM/zt74zDAOO48B13cTGZrMBz/ORpfg3kRvKcDi8W/BwOKDb7WI0GkEQhLv8n6TT6WC5XKJUKt3mVqsVJpPJ6xvKvyCEgOf5REecMmR5SS4tZHJpJZNLK5lcWsnk0koml1YyubSSyaWVTC6tfPuYwbZtFItFNBqNl76OX2U6nUIUxW8dM8SWo5TC8zzYtg1RFNnURAiCAJIk3a7/3+Rc14VlWahWqw/P5n+a68OVZRn5fD5SLlbPXRet1WpvEwMAURQhSRIMw4j1/yJS7vrGFEVJ9CjvEYVCAfV6HaZpwvd9NnxHZFn2ej0QQvD19cWG34rneTgej5jP5w/L8qncer3GYrFAGIZs6GNot9vQNI2dBqLk0k5kz6WZPxOkkh1wY5FbAAAAAElFTkSuQmCC","dark-oak":"iVBORw0KGgoAAAANSUhEUgAAAEAAAAAnCAYAAAC/mE48AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAK7SURBVGhD7ZldT9NQGMf/PVvXbmMvDAaO7EIimHEh3pndaGLiBR+DF/WaT+CX8N6PgEYzEy9NvDGZJBqNYtiGjJdhYbB23ejW9niBJnKyaA+wstD+kt78n6dpzq99zsWpQCml8DCEDbyGL4ANvIbAswdQSqFpGgzDYEsDAyEEqVQKgiCwpZ5wCdB1HcvLyygUCggQZw9wE5sCqVQKxWIRkiSx5Z5wCWg2m1hYWMDbNwXcz00gE4+ADIiIum7gfWUPh5aIjR+bkGWZbekJt4DHS4uI7n7GxoGGsVgY10djbJvr1BotbNabiIdDKO62sFaqOBbAvwkKAiKhIGYyw/iptlFWGmyHqyhaG2VFRXY4ikwi4nj2/8Av4DcxWcTUeAKKZqCiqNCNruvXUauDyr6GyXQcE8ko+JZ+Av8IPFxCev8rhmTxJDO6KG4oaFhBiOJJ5ga2bUM9quPBTBbpmAxBEKC2O3i1doBv62XHI3BuARTAh50mnjx9hnw+z97SN2q1GnJTk3h0bwZhMQgAZxJw5hE4jQBCCAKBgKvXRXBBAgYLno3wSgrgwRfABl7DF8AGXsMXwAZewxfABl7DF8AGXsMXwAZewxfABl7D8wLOfSRmU4p3JQWJG7NIp0fZW/rGcfsYr1++wOLdHCKh00dia6VK/36M/C3AMC1UFBWtjol4OMS29x3Lpmh3LEyPxxGVRHcFyGIA3/eO0DRM3M6OQBIv5oyOB5tSrO81oBsmcpkkupbNLeDMe0BJUaEbJu5Mjl3K4gGACAJuXkuCEODTVh3trsW2/BduAZZN8bF6AO24i1vZEbZ8KcxmR5GMhPBlp46uZbPlf8I9AvPz83i+soLp8QSk4OW8+V6Yto2tQx3SUALVatXxCHAJME0Tq6ur2N7eZksDgyRJmJubAyHOPm4uAVcRZ5quML8AHOWVjWy7fkoAAAAASUVORK5CYII=","amber":"iVBORw0KGgoAAAANSUhEUgAAAD0AAAApCAYAAACGJSFkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAKxSURBVGhD7ZndS1NhHMe/55yZx7000l40nekczsyS2CSoIIlernLg0u7KCyGCCLroL+g/yIuuoov1D6ybjILAkhmi0eaYMh24F5nYtna2udRtp4tA8FnSOcqOy+d84Fyc5/c9cD48z+9c/A4jiqIIymDJBRpQpWmBSmlG6oesUChAEAQUi0WyVDXwPA+DwUAulyFZOhAIYGRkBLFoFBxXXQdEFEUUSyUMDjoxNjZGlsuQLO3z+TA85ER9nQjnjT4cO6oFGIaMKY8owhuM4u2nWVzuvw2Xy0UmypAl/fTxKG7a2uBfjOHSBTNONRjJmOJ89S5ByOZRKJWwqW2VJC3rnGpYDuaWk7C2NeLzzALiP36SEcUolURMeZcQXU3C1tOO40Y9GdkVWTv97MlDjA7Y/twHI4jEk+ixtMCoryPjFWd5JYFwPIFr9i4YdDymfSGsbNVL2uk9SwNAcHkV45NzKIgcGAX7e2NzE6YTetzpvwiDjgcA5aQT6Swm/Em8fOWCTqfbka8kbrcbr188xwPH1e01OdKyevpvMAzAsiw4jlPsYtn9vfb+nv5PUaVpQZWmBVWaFlRpWlClaUGVpgVVmhZUaVrY17hoLZXBm3cz6OjqhUZTsyNfSSKRMPhCEvcHrmzP5uSMi/YsnRJymJ4LQcvXoq72CBmvOEkhiwajHuc7TajRcJWXFrJ5jH/xwtrehO6OZtRoODJecTK5X3g/6UPnmUZ0mZvwfT4sWVp2T+fyG/g45Ue3pRm91tYDEQYAg47H3Vt9mJhdgH8xhi0ZPxZlSacyOXzw+NHa1ICz5tNk+UB4dO864ok0vgXCZGlXZB1vh8MBIbWGc5YWsKxyw/1/kc7kMR9agXNoWNLxliwtCAI8Hg/W19fJUtVgMplgt9vJ5TIkSx8mZPX0YYFK6d9HxjoZM/7LUwAAAABJRU5ErkJggg=="};
  function frameArtwork(kind) {
    if (!Object.prototype.hasOwnProperty.call(phReviewClientIcons,kind)) return null;
    var wrap=el('span','ph-review__frame-art ph-review__frame-art--'+kind);
    wrap.setAttribute('aria-hidden','true');
    var img=el('img','ph-review__frame-icon');
    img.alt='';
    img.loading='eager';
    img.decoding='async';
    img.src='data:image/png;base64,'+phReviewClientIcons[kind];
    wrap.appendChild(img);
    return wrap;
  }

  // Show concise labels like the reference while leaving option.value and
  // screen-reader names unchanged; respect the currently rendered language.
  function compactFinishLabel(kind, original) {
    var hebrew = /[\u0590-\u05ff]/.test(original) || /^he\b/i.test(document.documentElement.lang || '');
    var label = {
      print: hebrew ? 'ללא מסגרת' : 'No frame',
      black: hebrew ? 'שחור' : 'Black',
      'dark-oak': /dark oak|אלון\s*כהה/i.test(original) ? (hebrew ? 'אלון כהה' : 'Dark oak') : (hebrew ? 'וונגה' : 'Wenge'),
      'light-oak': hebrew ? 'אלון בהיר' : 'Light oak',
      amber: hebrew ? 'ענבר' : 'Amber'
    };
    return label[kind] || original;
  }

  function syncSelect(select, buttons) {
    var chosen = select.value;
    toArray(buttons.querySelectorAll('button[data-ph-v2-value]')).forEach(function (button) {
      var active = button.getAttribute('data-ph-v2-value') === chosen;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function setValue(select, value) {
    // The real select remains authoritative for price, availability, cart and gallery.
    // Kingdom's handlers are jQuery-bound; a native event alone is not always enough.
    if (select.value === value) return;
    select.value = value;
    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(select).trigger('change');
    } else {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function enhanceSelect(select) {
    if (!select || select.dataset.phV2Enhanced === '1') return;
    var holder = select.closest('.product__variant-holder');
    var kind = getKind(select);
    var opts = toArray(select.options);
    if (!holder || !kind || opts.length === 0 || opts.length > 8) return;
    // Kingdom may filter the native frame selector down to just "Printing only"
    // when no frames are purchasable for the selected print size. The UI must
    // remain a set of tiles, with non-purchasable finishes visibly disabled.
    if (kind === 'frame') {
      var raw = holder.querySelector('[data-ph-v2-frame-values]');
      var allValues = [];
      try { allValues = raw ? JSON.parse(raw.textContent || '[]') : []; } catch (e) { allValues = []; }
      if (Array.isArray(allValues) && allValues.length && allValues.length <= 8) {
        opts = allValues.map(function(value) {
          value = String(value);
          var nativeOption = toArray(select.options).find(function(o) { return o.value === value; });
          return nativeOption || { value:value, textContent:value, disabled:true, phV2Filtered:true };
        });
      }
    }
    if (opts.length < 2 && kind !== 'frame') return;
    // No replacement until Kingdom has initialized its native control.
    if (!holder.querySelector('.regular-select-cover')) return;
    var existing = holder.querySelector('.ph-v2__option-grid--' + kind);
    if (existing) existing.remove();

    var group = el('div', 'ph-v2__option-grid ph-v2__option-grid--' + kind);
    group.setAttribute('role', 'group');
    var label = holder.querySelector('label');
    if (label) group.setAttribute('aria-label', (label.textContent || '').trim());
    // Presentation order from client's 4-icon reference. Never reorder the
    // original Shopify <select> or change its selected option / variant ID.
    var shownOpts = opts;
    if (kind === 'frame') {
      var frameRank = {black:0,'dark-oak':1,'light-oak':2,amber:3,print:4};
      shownOpts = opts.slice().sort(function(a,b) {
        var aFinish = getFinish(a.value), bFinish = getFinish(b.value);
        var aRank = frameRank[aFinish] === undefined ? 10 : frameRank[aFinish];
        var bRank = frameRank[bFinish] === undefined ? 10 : frameRank[bFinish];
        return aRank - bRank;
      });
    }
    shownOpts.forEach(function (option) {
      var b = el('button', 'ph-v2__option ph-v2__option--' + kind);
      b.type = 'button';
      b.setAttribute('data-ph-v2-value', option.value);
      b.setAttribute('aria-pressed', 'false');
      b.disabled = option.disabled;
      if (option.phV2Filtered) {
        // V10 inventory guard may re-evaluate this state when print size changes.
        b.setAttribute('data-ph-v10-original-disabled','false');
      }
      var labelText = option.textContent.trim();
      if (kind === 'frame') {
        var finishKind = getFinish(option.value);
        // Oak finishes use a neutral frame swatch; Wenge keeps its approved icon.
        var visual = finishKind === 'dark-oak' && /dark oak|אלון\s*כהה/i.test(labelText)
          ? null : frameArtwork(finishKind);
        if (visual) {
          b.appendChild(visual);
          b.classList.add('ph-review__frame-card');
          b.classList.add('ph-review__frame-card--' + finishKind);
          b.setAttribute('aria-label', finishKind === 'print' ? compactFinishLabel(finishKind, labelText) : labelText);
        } else {
          // Other finish types retain the merchant's existing swatch behavior.
          b.appendChild(el('span', 'ph-v2__finish ph-v2__finish--' + finishKind));
        }
        b.appendChild(el('span', 'ph-v2__option-label', visual ? compactFinishLabel(finishKind, labelText) : labelText));
      } else {
        b.appendChild(el('span', 'ph-v2__option-label', labelText));
      }
      b.addEventListener('click', function () {
        if (b.disabled) return;
        // Never select a synthetic/filtered finish that Shopify has not exposed
        // as a valid native option for the currently chosen print size.
        if (!toArray(select.options).some(function(o) { return o.value === option.value && !o.disabled; })) return;
        setValue(select, option.value);
        syncSelect(select, group);
      });
      group.appendChild(b);
    });

    // No write to Shopify's select on mount; only mirror the existing selection.
    holder.appendChild(group);
    select.dataset.phV2Enhanced = '1';
    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(select).on('change.phV2', function () { syncSelect(select, group); });
    }
    select.addEventListener('change', function () { syncSelect(select, group); });
    syncSelect(select, group);
    holder.classList.add('ph-v2__selector-ready');
  }

  function initProduct(article) {
    if (!article || article.dataset.phV2Init === '1') return;
    article.dataset.phV2Init = '1';
    var root = article.querySelector('.product__variants');
    if (!root) return;
    function tryEnhance() {
      toArray(root.querySelectorAll('select.product__variant')).forEach(function (select) {
        if (select.dataset.phV2Enhanced === '1') return;
        var kind = getKind(select), n = select.options.length;
        if (!kind || n < 1 || n > 8 || (kind !== 'frame' && n < 2)) return;
        enhanceSelect(select);
      });
    }
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tryEnhance(); });
    }
    tryEnhance();
    if (window.MutationObserver) {
      // Keep watching: Kingdom can replace the frame select after size changes.
      // Previously the observer disconnected as soon as the size row mounted.
      new MutationObserver(schedule).observe(root, { childList:true, subtree:true });
    }
  }

  function initFilters() {
    var panel = document.querySelector('.template-collection .collection__filters');
    if (!panel || panel.dataset.phV2Ready === '1') return;
    panel.dataset.phV2Ready = '1';
    // Retain the existing #apply-sort-filter and #clear-sort-filter handlers.
    // Escape delegates to the existing close button to restore scroll and overlay.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !panel.classList.contains('opened')) return;
      var close = panel.querySelector('.collection__filters-close');
      if (close) close.click();
    });
  }

  function initSearch() {
    var trigger = document.querySelector('.sidebar__search-handle');
    if (!trigger || trigger.dataset.phV2Ready === '1') return;
    trigger.dataset.phV2Ready = '1';
    // Keep the original click binding (including predictive-search mode).
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-label', document.documentElement.lang === 'he' ? 'חיפוש' : 'Search');
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
    });
  }

  function mount() {
    if (!document.body || !document.body.classList.contains('ph-v2')) return;
    if (document.body.classList.contains('template-product') &&
        !document.body.classList.contains('template-product-portfolio')) {
      toArray(document.querySelectorAll('.product.page-section')).forEach(initProduct);
    }
    initFilters();
    initSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
